import React from 'react';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { Box, styled } from '@applatform/design-system';
import { fadeIn, rotate } from 'theme/animations';
import Container from 'components/V1/Container/Container';

interface SpinnerBaseProps {
  className?: string;
}

const SpinnerBase = ({ className }: SpinnerBaseProps) => {
  return (
    <div className={className}>
      <VisuallyHidden>Loading...</VisuallyHidden>
    </div>
  );
};

const Spinner = styled(SpinnerBase, {
  // Reset
  boxSizing: 'border-box',

  display: 'inline-block',
  width: '24px',
  height: '24px',
  borderColor: 'currentColor',
  borderStyle: 'solid',
  borderRadius: '99999px',
  borderWidth: '2px',
  borderLeftColor: 'transparent',
  color: '$primary',
  animation: `${rotate} 450ms linear 0ms infinite`,
});

export function FullPageSpinner() {
  return (
    <Box
      css={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        opacity: 0,
        animation: `${fadeIn} 600ms ease 400ms`,
        animationFillMode: 'forwards',
      }}
    >
      <Spinner />
    </Box>
  );
}

export function AuthenticatedAppSpinner() {
  return (
    <Container
      variant="main"
      css={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        opacity: 0,
        animation: `${fadeIn} 600ms ease 400ms`,
        animationFillMode: 'forwards',
      }}
    >
      <Spinner />
    </Container>
  );
}

export function PublicLayoutSpinner() {
  return (
    <Box
      css={{
        textAlign: 'center',
        mb: '$40',
        opacity: 0,
        animation: `${fadeIn} 600ms ease 400ms`,
        animationFillMode: 'forwards',
      }}
    >
      <Spinner />
    </Box>
  );
}

export default Spinner;
